// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"U1-z","dimensionLabel":"V1-z","styleChooserControlWrapper":"W1-z","styleChooserControl":"X1-z","disabled":"Y1-z","giftCard":"Z1-z","styleChooserText":"_1-z"};